exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unscoped--SimplePopup-editor-container .ck.ck-content,.unscoped--SimplePopup-editor-container .ck.ck-editor,.unscoped--SimplePopup-editor-container .ck.ck-editor__main{display:flex;flex-direction:column;height:100%}", ""]);

// exports
